import styles from './TagsDisplay.module.css';

/**
 * Componente para exibir múltiplas tags de informação
 * Usado na visualização da tabela (não editável)
 */
const TagsDisplay = ({ tags }) => {
  // Converter tags para array se necessário
  const parseTags = (valor) => {
    if (!valor) return [];
    if (Array.isArray(valor)) return valor;
    if (typeof valor === 'string') {
      try {
        const parsed = JSON.parse(valor);
        return Array.isArray(parsed) ? parsed : [valor];
      } catch {
        return [valor];
      }
    }
    return [];
  };

  const tagsArray = parseTags(tags);

  if (tagsArray.length === 0) {
    return <span className={styles.tagNormal}>Normal</span>;
  }

  const getTagConfig = (tag) => {
    switch (tag) {
      case 'recorrente':
        return { label: 'Recorrente', icon: '🔄', className: styles.tagRecorrente };
      case 'nao_comprar':
        return { label: 'Não Comprar', icon: '⊘', className: styles.tagNaoComprar };
      case 'promocao':
        return { label: 'Promoção', icon: '🏷', className: styles.tagNormal };
      case 'novo':
        return { label: 'Novo', icon: '🆕', className: styles.tagNormal };
      case 'destaque':
        return { label: 'Destaque', icon: '⭐', className: styles.tagNormal };
      case 'baixa_rotacao':
        return { label: 'Analise', icon: '🔍', className: styles.tagNormal };
      case 'mudar_foto':
      case 'refazer_foto':
        return { label: 'Refazer Foto', icon: '📷', className: styles.tagMudarFoto };
      case 'item_apoio':
        return { label: 'Item de Apoio', icon: '🛠️', className: styles.tagApoio };
      case 'refazer_preco':
        return { label: 'Refazer Preço', icon: '💲', className: styles.tagRefazerPreco };
      default:
        return { label: tag, icon: '●', className: styles.tagNormal };
    }
  };

  return (
    <div className={styles.tagsContainer}>
      {tagsArray.map((tag) => {
        const config = getTagConfig(tag);
        return (
          <span key={tag} className={`${styles.tag} ${config.className}`}>
            <span className={styles.icon}>{config.icon}</span>
            <span className={styles.label}>{config.label}</span>
          </span>
        );
      })}
    </div>
  );
};

export default TagsDisplay;

